import type { UseFetchOptions } from 'nuxt/app'
import { defu } from 'defu'

/**
 * useApi - Wrapper for useFetch that should only be called during setup
 * For calls after component is mounted, use $api from utils/api instead
 */
export const useApi = <T>(url: MaybeRefOrGetter<string>, options: UseFetchOptions<T> = {}) => {
  const config = useRuntimeConfig()
  const supabaseSession = useSupabaseSession()

  // Build a reactive headers computed so the Authorization token
  // always reflects the latest session (after silent refreshes).
  const authHeaders = computed(() => {
    const token = supabaseSession.value?.access_token

    return token ? { Authorization: `Bearer ${token}` } : {} as Record<string, string>
  })

  const defaults: UseFetchOptions<T> = {
    baseURL: (config.public.apiBaseUrl as string) || '',
    key: toValue(url),

    // useFetch resolves computed refs, so the header stays in sync
    headers: authHeaders as any,
  }

  // for nice deep defaults, please use unjs/defu
  const params = defu(options, defaults)

  return useFetch(url, params)
}
